import '../../../css/reset.css';
import '../../../css/common.css';
import '../../lib/object.assign';
import './contact.less';

import React,{Component} from 'react';
import ReactDOM from 'react-dom';
import LangUtil from '../../lang';
import Title from 'c-title';
import url from 'c-url';
require('../../lang/contact-show/pack');
const prefix = 'contact';
let lang = new LangUtil({
    LangPack: window.LangPack
});
class App extends Component{
    componentWillMount(){
        let name = url.query('name') || 'Uplive';
        Title.set(lang.template('页面标题<%=name%>', {'name':name}));
    }
    render(){
        let name = url.query('name') || 'Uplive';
        let extra      = lang.template('内容扩展-extra<%=name%>',{'name':name});
        let $innerHtml = extra == `内容扩展-extra${name}` ?
            lang.template('<%=name%>联系我们内容', {'name':name}):
            lang.template('<%=name%>联系我们内容', {'name':name}) + extra
        return(
            <div className={prefix+'-container page-container'}>
                <div className={prefix+'-content page-content'} dangerouslySetInnerHTML={{__html: $innerHtml}}></div>
            </div>
        )
    }
}
let el = document.getElementById('wrap');
ReactDOM.render(<App/>, el);



// WEBPACK FOOTER //
// ./js/pages/contact/contact.js